import './styles.scss'
import React from 'react'
import SidePopup from '../../SidePopup'

import PaymentMethodEdit from './PaymentMethodEdit'

class CompanyPaymentEdit extends React.Component {
  constructor(props) {
    super(props)

    this.hideModal = this.hideModal.bind(this)
  }

  hideModal(e) {
    if (e) e.preventDefault()
    this.props.history.goBack()
  }

  render() {
    return (
      <SidePopup onHide={this.hideModal} backButton>
        <PaymentMethodEdit
          redirectUrl={this.props.match.url.replace('/payment/edit', '')}
        />
      </SidePopup>
    )
  }
}

export default CompanyPaymentEdit
